export var LTO_EVENT_TYPES = {
  DISMISS_LTO_CONFIRMATION_SCREEN: 'DISMISS_LTO_CONFIRMATION_SCREEN',
  ACCEPT_LTO_CONFIRMATION_SCREEN: 'ACCEPT_LTO_CONFIRMATION_SCREEN'
};